import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row
} from "reactstrap";

import SelectListComponent from "../utils/selectList";

const SearchPanel = ({
  contentErrorText,
  airline,
  ticketClass,
  category,
  selectedAirline,
  selectedTicket,
  selectedCategory,
  onAirlineChange,
  onTicketChange,
  selectedFilterMode,
  onCategoryChange,
  onFilterModeValueChange,
  onMultiValueChange,
  onSearch
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row className={"text-center"}>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Airline</Label>
              <SelectListComponent
                data={airline}
                valueKey="Id"
                textField="Name"
                selectValue={selectedAirline}
                onValueChange={onAirlineChange}
              />
              <span style={{ color: "red" }}>{contentErrorText}</span>
            </FormGroup>
          </Col>
          <Col xs="6" sm="4">
            <FormGroup className="mb-4">
              <Label>Ticket Class</Label>
              <SelectListComponent
                data={ticketClass}
                valueKey="Name"
                textField="Name"
                selectValue={selectedTicket}
                onValueChange={onTicketChange}
              />
              <span style={{ color: "red" }}>{contentErrorText}</span>
            </FormGroup>
          </Col>
          <Col xs="6" sm="4">
            <FormGroup className="mb-4">
              <Label>Category</Label>
              <SelectListComponent
                data={category}
                valueKey="Id"
                textField="Name"
                selectValue={selectedCategory}
                onValueChange={onCategoryChange}
              />
              <span style={{ color: "red" }}>{contentErrorText}</span>
            </FormGroup>
          </Col>
          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch(1)}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/ticket-class-setup/search_panel.js